import List from './components/List'
import Form from './components/Form'

export default [
  {path: '/registration', component: List, name: 'registration.index'},
  {path: '/registration/store', component: Form, name: 'registration.store'},
  {path: '/registration/:id', component: Form, name: 'registration.update'}
]



// WEBPACK FOOTER //
// ./src/app/domains/registration/routes.js